/**
 * This service manages the authentication token.
 * It now uses localStorage to persist the token across page refreshes.
 */

// Define a key to use for storing the token in localStorage.
const AUTH_TOKEN_KEY = 'laqy_auth_token';

// We no longer need the in-memory `let token` variable.

export const authService = {
    /**
     * Saves the authentication token to localStorage.
     */
    setToken: (newToken: string) => {
        if (typeof window !== 'undefined') {
            localStorage.setItem(AUTH_TOKEN_KEY, newToken);
        }
    },

    /**
     * Retrieves the authentication token from localStorage.
     */
    getToken: (): string | null => {
        if (typeof window !== 'undefined') {
            return localStorage.getItem(AUTH_TOKEN_KEY);
        }
        return null;
    },

    /**
     * Removes the authentication token from localStorage.
     */
    clearToken: () => {
        if (typeof window !== 'undefined') {
            localStorage.removeItem(AUTH_TOKEN_KEY);
        }
    },

    /**
     * Checks if a token exists in localStorage.
     * The `!!` converts the string (or null) to a boolean.
     */
    isAuthenticated: (): boolean => {
        const token = authService.getToken();
        return !!token;
    },
};
